import React, { useEffect, useState } from 'react';
import {
  Modal,
  Input,
  Dropdown,
  Button,
  Textarea,
  Select,
  InfoCard,
  Tooltip,
} from 'app/components';
import {
  CaretLeft,
  CaretCircleRight,
  CaretDown,
  CaretUp,
  Question,
  Sparkle,
  Info,
} from '@phosphor-icons/react';
import Slider from './slider';
import BreakupDetails from './breakupDetails';

const AddTicketDetails = ({
  onSave,
  onPGchange,
  isOpen,
  onClose,
  ticket,
  existingTickets,
  setHasUnsavedChanges,
  isAdmin,
  allowNameEdit,
  priceBreakups,
  getPriceBreakup,
  gst = true
}) => {
  const [showBreakup, setShowBreakup] = useState(false); //actual price breakup
  const [showAdvanced, setShowAdvanced] = useState(false);
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    id: '',
    ref_id: '', // copy of id
    option_key_1: 'PASS',
    option_value_1: '',
    price: '',
    quantity: '',
    available_quantity: '',
    max_occupancy: 1,
    is_fee_owned_by_user: false,
    description: '',
    is_paid: false,
    is_active: true,
  })

  const ticketPrice = parseFloat(formData.price) || 0;
  const buyerFee = ticketPrice * 0.02;
  const eventOrgFee = ticketPrice * 0.01;
  const gateWayFee = ticketPrice * 0.02;
  const [gatewaySelect, setGatewaySelect] = useState(0);
  const totalBuyerFee =
    !formData.is_fee_owned_by_user
      ? ticketPrice + buyerFee
      : ticketPrice + buyerFee + gateWayFee;

  // Calculating organization money
  const orgMoney =
    !formData.is_fee_owned_by_user
      ? ticketPrice - (gateWayFee + eventOrgFee)
      : ticketPrice - eventOrgFee;

  const [showGatewayWarning, setShowGatewayWarning] = useState(false);
  const [hasGatewayWarningShown, setHasGatewayWarningShown] = useState(false);

  const handleWhoPaysChange = (is_fee_owned_by_user) => {
    if (existingTickets?.length > 0 && !hasGatewayWarningShown) {
      setShowGatewayWarning(true);
      return;
    }

    setFormData({ ...formData, is_fee_owned_by_user });

    onPGchange(is_fee_owned_by_user);
    setFormData({ ...formData, is_fee_owned_by_user });
  };

  const handleGatewayWarningConfirm = () => {
    setHasGatewayWarningShown(true);
    setShowGatewayWarning(false);
    let newPGValue = !formData.is_fee_owned_by_user;
    onPGchange(newPGValue);
    setFormData({ ...formData, is_fee_owned_by_user: newPGValue });
  };

  const handleGatewayWarningClose = () => {
    setShowGatewayWarning(false);
  };

  // Use effect to reset the form data when the modal is opened
  // useEffect(() => {
  //   if (isOpen) {
  //     setFormData((prevFormData) => ({
  //       ...prevFormData,
  //       option_value_1: '',
  //     }));
  //   }
  // }, [isOpen, formData.is_paid]);

  useEffect(() => {
    if (formData.ticketsSold > 0) {
      setPaid(true);
    }
  }, [formData]);
  // Define the options for the dropdown

  useEffect(() => {
    if (ticket) {
      setFormData(ticket);
    } else {
      setFormData({
        id: '',
        ref_id: '',
        option_key_1: 'PASS',
        option_value_1: '',
        price: '',
        quantity: '',
        available_quantity: '',
        max_occupancy: 1,
        is_fee_owned_by_user: existingTickets?.[0]?.is_fee_owned_by_user ?? false,
        description: '',
        is_paid: true,
        is_active: true,
      });
    }
  }, [ticket]);

//   useEffect(() => {
//   if (window.Tawk_API) {
//     window.Tawk_API.hideWidget();
//   }

//   return () => {
//     if (window.Tawk_API) {
//       window.Tawk_API.showWidget();
//     }
//   };
// }, []);


  const toPascalCase = (str) => {
    return str
      .replace(/(^\w|[\s-]+\w)/g, match => match.toUpperCase())
      .replace(/[\s-]/g, ' ');
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const valueUpdate = name === 'option_value_1' ? toPascalCase(value) : value;
    // if quantity of live ticket is edited, modify the available quantity as well accordingly.
    if (name === 'quantity') {
      const sold = (formData?.quantity || 0) - (formData?.available_quantity || 0);
      const updatedAvblQ = Number(valueUpdate) - sold;
      setFormData({
        ...formData,
        [name]: valueUpdate,
        available_quantity: updatedAvblQ,
      });
    } else {
      setFormData({
        ...formData,
        [name]: valueUpdate,
      });
    }
    setHasUnsavedChanges(true);
  }

  const validateForm = () => {
    const errors = {};

    if (!formData.option_value_1.trim()) {
      errors.option_value_1 = 'Ticket category name is required';
    } else if (existingTickets?.some(ticket => ticket.option_value_1 === formData.option_value_1 && ticket.id !== formData.id)) {
      errors.option_value_1 = 'Ticket category name must be unique'
    }

    if (!String(formData.quantity).trim()) {
      errors.quantity = 'Quantity is required';
    } else if (!/^\d+$/.test(formData.quantity)) {
      errors.quantity = 'Quantity must be a number';
    } else if (parseInt(formData.quantity, 10) === 0) {
      errors.quantity = 'Quantity cannot be zero';
    } else if (parseInt(formData.quantity, 10) <= 0) {
      errors.quantity = 'Quantity must be a positive number';
    } else if (formData.quantity.length > 8) {
      errors.quantity = 'Quantity cannot be more than 8 digits.';
    } else if (formData.available_quantity < 0) {
      errors.quantity = 'Quantity cannot be less than the number of tickets sold.';
    }

    if (formData.is_paid) {
      if (!String(formData.price).trim()) {
        errors.price = 'Price is required';
      } else if (!/^\d+$/.test(formData.price)) {
        errors.price = 'Price must be a number';
      } else if (formData.price.length > 8) {
        errors.price = 'Price cannot be more than 8 digits.';
      } else if (parseInt(formData.price, 10) === 0) {
        errors.price = 'Price cannot be zero';
      } else if (parseInt(formData.price, 10) <= 0) {
        errors.price = 'Price must be a positive number';
      }
    }

    if (formData.description.length > 100) {
      errors.description = 'Description should not exceed 100 characters';
    }
    setErrors(errors);
    return Object.keys(errors).length === 0
  }

  const handleSubmit = () => {
    if (!formData.id) {
      formData.id = Date.now().toString();
      formData.ref_id = formData.id;
    }
    if (validateForm()) {
      onSave(formData);
    }
  }
  const handleOkayGotIt = () => {//in breakup details
    setShowBreakup(false);
  };

  const handleDropdownChange = (selectedValue) => {
    setFormData({
      ...formData,
      option_key_1: 'PASS',
      option_value_1: '',
      price: '',
      quantity: '',
      available_quantity: '',
      max_occupancy: 1,
      is_fee_owned_by_user: existingTickets?.[0]?.is_fee_owned_by_user ?? false,
      description: '',
      is_paid: !!(selectedValue === 'Paid'),
    });
  };


  // Handle click event for toggling advanced settings
  const handleAdvanced = () => {
    setShowAdvanced((prevShowAdvanced) => !prevShowAdvanced);
  };

  // Handle click event for viewing breakup details
  const handleViewBreakup = () => {
    if (!priceBreakups?.[formData?.price]) {
      getPriceBreakup(formData?.price);
    }
    setShowBreakup(true);
  };

  // Handle click event for closing breakup details
  const handleCloseBreakup = () => {
    setShowBreakup(false);
  };
  // console.log(formData.selectedOption);
  const formatPrice = (price) => {
    return price.toFixed(0).replace(/(\d)(?=(\d\d)+\d$)/g, '$1,')
  }


  return (
    <Modal
      isOpen={isOpen}
      primaryText={showBreakup ? 'Okay, got it!' : "Save"}
      secondaryText={showBreakup ? null : 'Cancel'}
      onClickPrimaryCta={showBreakup ? handleOkayGotIt : handleSubmit}
      onClickSecondaryCta={onClose}
      className={`ticket-details h-auto scrollbar-thin scrollbar-webkit ${showBreakup ? 'secondary-cta-hidden' : ''
        }`}
      size= {'medium'}
      title={
        showBreakup ? (
          <div className="breakup-header flex items-center w-full">
            <div className='breakup-back bg-grey-10 p-3 rounded-full'>
              <CaretLeft
                size={24}
                weight="light"
                onClick={handleCloseBreakup}
              />
            </div>
            <div className="breakup-title flex justify-center w-full">
              Breakup for a ticket
            </div>
          </div>
        ) : (
          <div className="flex w-full ">
            {(isAdmin || allowNameEdit) ? 'Edit ticket details' : (formData.option_value_1 ? `Edit ${formData.option_value_1} details` : 'Add ticket details')}
          </div>
        )
      }
    >
      <div className=" overflow-x-hidden w-full">
        {showBreakup ? (
          <BreakupDetails
            priceBreakup={priceBreakups?.[formData?.price]}
          />
        ) : (
          <div className="flex flex-col gap-6">
            {(allowNameEdit || !formData?.id) && <div className='flex w-full gap-2'>
              <Select
                className="grow flex-1"
                label="Free"
                selected={!formData.is_paid}
                onClick={() => handleDropdownChange('Free')}
              />
              <Select
                className="grow flex-1"
                label="Paid"
                selected={!!formData.is_paid}
                onClick={() => handleDropdownChange('Paid')}
              />
            </div>}
            <>
              {(isAdmin || allowNameEdit || !formData?.id) && (
                <Input
                  name='option_value_1'
                  value={formData.option_value_1}
                  width="100%"
                  label="Name"
                  onChange={handleChange}
                  validationStatus={errors.option_value_1 ? 'error' : null}
                  helpText={errors.option_value_1}
                  required
                  placeholder={'Early Bird, Bronze, General etc.'}
                  autoFocus
                  className='w-full'
                />
              )}

              <div className="flex flex-col md:flex-row justify-between gap-3 items-baseline w-full">
                {formData?.is_paid && (isAdmin || allowNameEdit || !formData?.id) && <Input
                  name="price"
                  value={formData.price}
                  width="100%"
                  disabled={formData.isPriceEditable}
                  contentLeft="₹"
                  label={gst ? "Price (incl. of all Taxes)" : "Price"}
                  labelIcon={
                    gst ? (
                      <Tooltip className="text-center" content="Depositing GST to the government is your responsibility">
                        <p className="inline-block">
                          <Question className="inline-block" size={20} />
                        </p>
                      </Tooltip>
                    ) : null
                  }
                  onChange={handleChange}
                  className="flex-1"
                  validationStatus={errors.price ? "error" : null}
                  helpText={errors.price}
                  required
                  placeholder=""
                  type="number"
                  maxLength={8}
                />}
                <Input
                  name="quantity"
                  value={formData.quantity}
                  width="100%"
                  disabled={formData.isQuantityEditable}
                  label="Available quantity"
                  onChange={handleChange}
                  className="flex-1"
                  validationStatus={errors.quantity ? "error" : null}
                  helpText={errors.quantity}
                  required
                  placeholder=" "
                  type="number"
                  maxLength={8}
                />
              </div>
              <div className="flex justify-between">
                <div className="label-16 text-grey-70">
                  Max tickets per transaction
                </div>
                <div className="label-16">
                  {formData.max_occupancy === 1
                    ? `${formData.max_occupancy} ticket`
                    : `${formData.max_occupancy} tickets`}
                </div>
              </div>
              <Slider
                isPaid={formData.is_paid}
                available_quantity={formData.available_quantity}
                onSliderChange={(value) =>
                  setFormData({ ...formData, max_occupancy: value })
                }
                sliderValue={formData.max_occupancy}
                setFormData={setFormData}
                formData={formData}
              />
              {/* <button onClick={handleAdvanced}>
                <div className="label-16 text-grey-70 flex  justify-between">
                  Advanced settings
                  {formData.advanced ? (
                    <CaretUp size={24}
                      color="#878787" />
                  ) : (
                    <CaretDown size={24}
                      color="#878787" />
                  )}
                </div>
              </button> */}
              <Textarea
                name='description'
                width="100%"
                className={`w-full mb-4 md:mb-14 ${formData.is_paid ? 'mb-8' : ''}`}
                value={formData.description}
                onChange={handleChange}
                disabled={formData.isDescriptionEditable}
                validationStatus={
                  errors.description ? 'error' : null
                }
                helpText={errors.description}
                label="Ticket description (Optional)"
              />
              {showAdvanced && (
                <div className="overflow-y-auto overflow-x-hidden flex flex-col gap-6">
                  {((isAdmin || allowNameEdit) && formData.is_paid) && (  //here i check is the ticket is in edit mose and if atleast one ticket is sold, if so dont show this
                    <>
                      <div className="flex gap-1.5 ">
                        <div className="label-16 text-grey-70 ">
                          Who will pay the Payment Gateway fees?
                        </div>
                        <span>
                          <Tooltip content="The payment gateway fees are the charges applied by the payment processing service on ticket sales.">
                            <Question size={20}
                              color="#878787" />
                          </Tooltip>
                        </span>
                      </div>
                      <div className="flex gap-3">
                        <Select
                          label={'Me'}
                          width={250}
                          onClick={() => handleWhoPaysChange(false)}
                          selected={!formData.is_fee_owned_by_user}
                        />
                        <Select
                          label={'Buyer'}
                          width={250}
                          onClick={() => handleWhoPaysChange(true)}
                          selected={!!formData.is_fee_owned_by_user}
                        />
                      </div>
                    </>
                  )}
                  <InfoCard
                    icon={(<Info size={24} color="#101010" weight="fill" />)}
                    content={<div className="label-16">This applies to all paid ticket types. You can’t change it per category.</div>}
                  />
                  {showGatewayWarning && (
                    <Modal
                      isOpen={showGatewayWarning}
                      title="Change Gateway Fee Handling"
                      primaryText="Proceed"
                      secondaryText="Cancel"
                      onClickPrimaryCta={handleGatewayWarningConfirm}
                      onClickSecondaryCta={handleGatewayWarningClose}
                    >
                      <p>Changing this will affect all tickets. Do you want to proceed?</p>
                    </Modal>
                  )}
                  {(formData?.id && formData?.is_paid) && (
                    <InfoCard
                      icon={(<Sparkle weight='fill' />)}
                      content={`Payment Gateway Fee is borne by ${!formData.is_fee_owned_by_user ? 'you' : 'buyer'}. `}
                    />
                  )}
                </div>

              )}
              {formData.is_paid && formData?.price > 0 && (
                <div className="breakup-sticky-bar flex gap-2 bg-light p-3 pr-5 rounded-3xl z-40 items-center md:absolute md:left-[28px] md:bottom-[130px] w-full md:w-auto mt-4 md:mt-0">
                  <div className="bg-white rounded-full p-1 self-center">
                    <Sparkle size={24}
                      color="#FF2459"
                      weight="fill" />
                  </div>
                  <div className="text-16 items-center flex gap-1">
                    How much you’ll get – With & without GST
                  </div>
                  <Button
                    onClick={handleViewBreakup}
                    className="cursor-pointer p-0 m-0 border-none"
                    type="tertiary-text"
                  >
                    <div className="heading-16 items-center text-primary flex gap-1 cursor-pointer">
                      View breakup{' '}
                      <CaretCircleRight
                        size={24}
                        color="#FF2459"
                        weight="fill"
                      />
                    </div>
                  </Button>
                </div>
              )}
            </>
          </div>
        )}
      </div>
    </Modal>
    );
};

export default AddTicketDetails;
